module.exports = __webpack_public_path__ + "img/ck-page-share-footer.c6eb1525.png";